import type { TranslationsMap } from "../types/language";

// Checks if a given date(string) is before today
export function isBeforeToday(dateString: string) {
  const today = new Date();
  today.setHours(23, 59, 59, 999);

  const date = new Date(dateString);
  today.setHours(0, 0, 0, 0);

  if (today > date) {
    return true;
  }
}

// Displays the postingDate date in formats according to chosen language
export function displayDate(
  date: string,
  text: TranslationsMap,
  locale?: string
) {
  const regExp = new RegExp(/-/g);

  // Format: YYYY/MM/DD
  const englishDate = <span>{date.replace(regExp, "/")}</span>;
  // Format: DD.MM.YYYY
  const germanDate = <span>{date.split("-").reverse().join(".")}</span>;
  // Format: DD/MM/YYYY
  const spanishDate = <span>{date.split("-").reverse().join("/")}</span>;
  // Format: YYYY. MM. DD.
  const hungarianDate = <span>{date.replace(regExp, ". ")}</span>;

  // If no locale is provided, use the text.i18n value
  const actualLocale = locale || text.i18n;

  // Displays date format based on language/locale
  switch (actualLocale) {
    case "en":
      return englishDate;
    case "de":
    case "cs":
    case "ro":
      return germanDate;
    case "hu":
      return hungarianDate;
    case "es":
    case "fr":
      return spanishDate;
    case "sv":
      return date;
    default:
      return englishDate;
  }
}

export function getCurrentYear() {
  return new Date().getFullYear();
}

// Formats a date(string) as German DD.MM.YYYY. Returns "" for empty/invalid input.
export function formatGermanDate(dateString?: string | null): string {
  if (!dateString) {
    return "";
  }
  const date = new Date(dateString.slice(0, 10));
  if (Number.isNaN(date.getTime())) {
    return "";
  }
  return date.toLocaleDateString("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

// Accepts a string in the format "DD.MM.YYYY, HH:MM" and returns true if the date is before the current date and time

export function isBeforeDeadline(deadlineString: string) {
  const [datePart, timePart] = deadlineString.split(",");

  const [day, month, year] = datePart.split(".").map(Number);

  let hour = 0;
  let minute = 0;

  // If the time part is present, parse it
  if (timePart) {
    [hour, minute] = timePart.split(":").map(Number);
  }

  const deadline = new Date(year, month - 1, day, hour, minute);
  const now = new Date();

  return now <= deadline;
}
